<template>
  <div class="container bottom-fix-padding">
    <div class="navi">
        <span class="icon-arrow-left" @click="goto('/baggage-step2')"></span>
    </div>
    <div class="title">中国收件地址</div>
    <div class="weui-cells__title">收件信息</div>
    <div class="weui-cells weui-cells_form">
        <div class="weui-cell">
            <div class="weui-cell__hd"><label class="weui-label">收件人</label></div>
            <div class="weui-cell__bd">
                <input class="weui-input" type="text" placeholder="请输入收件人姓名" v-model="order.data.home_address[0].home_name"/>
            </div>
        </div>
        <div class="weui-cell weui-cells_form">
            <div class="weui-cell__hd">
                <label class="weui-label">联系手机</label>
            </div>
            <div class="weui-cell__bd">
                <input class="weui-input" type="tel"  pattern="[0-9]*" placeholder="请输入收件人手机号" v-model="order.data.home_address[0].home_phone" />
            </div>
        </div>
    </div>
    <div class="weui-cells__title">收件地址</div>
    <div class="weui-cells weui-cells_form">
        <div class="weui-cell">
            <div class="weui-cell__bd">
              <textarea class="weui-textarea" placeholder="请按省、市、区、街道填写" rows="4"  v-model="order.data.home_address[0].home_address"></textarea>
            </div>
        </div>
    </div>

    <div v-show="localErrorShow">
        <div class="weui-mask"></div>
        <div class="weui-dialog">
            <div class="weui-dialog__bd">{{localError[0]}}</div>
            <div class="weui-dialog__ft">
                <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="localErrorShow=false">好的</a>
            </div>
        </div>
    </div>
    <div class="btn-box-fix">
      <div class="btn-container">
        <div class="btn" @click="nextStep()" :class="{ active: allFilled()}" >下一步</div>
      </div>
    </div>
    <img :src="pixelURL('baggage','dizhi')" class="hide">
  </div>
</template>

<script>
export default {
  name: 'step3',
  data () {
    return {
      'order':{},
      'localError':[],
      'localErrorShow':false,
    }
  },
  created: function () {
    if (localStorage.order) {
      let localParsed = JSON.parse(localStorage.order);
      if(localParsed.service == "baggage"){
        this.order = localParsed;
        document.querySelector("html").classList.add("grey-background");
      }
      else{
        this.$router.push('/');
      }
    }
    else{
      this.$router.push('/');
    }
  },
  destroyed() {
    document.querySelector("html").classList.remove("grey-background");
  },
  methods: {
    allFilled(){
       if(this.order.data.home_address[0].home_name &&
          this.order.data.home_address[0].home_phone &&
          this.order.data.home_address[0].home_address ){
            return true;
        }
    },
    checkSubmit(){
        this.localError = [];
        if (!this.order.data.home_address[0].home_name) {
            this.localError.push("请填写收件人姓名");
        }
        if (!this.order.data.home_address[0].home_phone) {
            this.localError.push("请填写收件人手机号");
        }
        if (!this.order.data.home_address[0].home_address) {
            this.localError.push("请填写中国收件地址");
        }
        if (!this.localError.length) {
          return true;
        }
        else{
          this.localErrorShow = true;
          return false;
        }
    },
    nextStep: function() {
        if(!this.checkSubmit()){
            return false;
        }
        else{
            this.orderUpdateAll('/baggage-step2');
        }
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.main{
  padding:20px 20pt 0 20pt;
}
.hr{
  border-top:1px solid #eee;
  margin:16pt 0;
}
.address-empty{
  color:#ccc;
  font-size:1.2em;
}

.address-detail{
  color:#666;
  font-size:1.1em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.address-parking{
  color:#aaa;
  font-size:1em;
}

.arrow-right{
  color:#ddd;
}
.move-title{
  font-weight:bold;
  font-size:1.2em;
  color:#555;
  margin-bottom:4pt;
}

.waypoint{
  font-weight:bold;
  font-size:1.2em;
  color:#777;
  margin-bottom:4pt;
}

select{
  -webkit-appearance: none;
  border: 0;
  outline: 0;
  background-color: transparent;
  width: 100%;
  font-size: inherit;
  height: 45px;
  line-height: 45px;
  position: relative;
  z-index: 1;
}

.fade-enter-active{
  transition-duration: 0.5s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.check-detail{
  border: 2px solid #e3e3e3;
  padding: 8px 18px 8px 14px;
  margin-top: 14px;
  display: inline-block;
  border-radius: 50px;
}

.more-detail{
  text-align:center;
  margin-bottom:20px;
}

</style>



// WEBPACK FOOTER //
// src/pages/baggage/step2-to.vue